import React from "react";
import Navbar from "./global-components/navbar-v2";
import PageHeader from "./global-components/page-header";
import Service from "./section-components/service-v5";
import Cta from "./section-components/cta-v10";
import FaqV2 from "./section-components/faq-v2";
import Testimonial from "./section-components/testimonial-v2";
import Brand from "./section-components/brand-v4";
import Case from "./section-components/case";
import Footer from "./global-components/footer-v2";

const ServiceV1 = () => {
  let ServiceObject = {
    serviceHeading:
      "Our specialized lead generation services attract, engage, and convert potential customers into high-quality leads, driving revenue growth for your business. Utilizing data-driven strategies and targeted marketing campaigns, we increase brand visibility, generate more leads, and optimize conversion rates.",
    servicePointsLoop: [
      "Drive revenue growth with high-quality leads through targeted marketing.",
      "Increase brand visibility and generate more leads with our specialized lead generation services.",
      "Convert potential customers into meaningful leads using data-driven strategies.",
      "Optimize conversion rates and achieve long-term growth and increased sales.",
    ],
    serviceDiv: [
      {
        heading: "Pilot Campaign & Traction",
        description: "Drive Traction, Achieve Sustainable Growth.",
      },
      {
        heading: "Cut wasteful efforts",
        description:
          "Cut Wasteful Efforts, Optimize Resource Allocation for Enhanced Productivity.",
      },
      {
        heading: "Lead Optimization",
        description: "Lead Optimization for Maximum Quality and Conversion.",
      },
      {
        heading: "Scale successful efforts",
        description:
          "Scaling Successful Initiatives for Business Growth. Amplify and Extend Effective Strategies to Drive Scalable Results.",
      },
    ],
  };
  let workWithUs =
    "Ignite Growth with Expert Lead Generation Services. We specialize in attracting, engaging, and converting potential customers into high-quality leads, driving revenue growth and increasing your brand's visibility.";

  return (
    <div>
      <Navbar />
      <PageHeader headertitle="Lead Genration" />
      <Service serviceDetail={ServiceObject} />
      <Cta workWithUs={workWithUs} />
      <FaqV2 />
      <Testimonial />
      <Brand />
      <Case customclass="case-one case-one__team-page case-one__service-page" />
      <Footer />
    </div>
  );
};

export default ServiceV1;
